<div class="heading">
  {{ heading }}

  <hf-toggle [formControl]="toggleControl"></hf-toggle>
</div>
